export default __webpack_public_path__ + "assets/images/f11ff6b5f9e299c3482c3aa577b8fc42.png";